/** Shared bits for the Legal Diary process editor (A1). */
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

export const OWNER_ROLE_LABELS = {
  case_legal_handler: "Case legal owner (paralegal)",
  case_handler: "Account owner (collector)",
  legal_head: "Head of Legal",
  unassigned: "Unassigned (panel)",
};

export const KIND_LABELS = { timer: "Timer", task: "Task", reminder: "Reminder", email: "Email" };

export const TRIGGER_GROUP = (trigger) =>
  trigger.startsWith("legacy_stage:") ? "Legacy tracker (retiring)" : trigger.startsWith("route_entered:") ? "Retired — bankruptcy route actions live on the Timelines" : "When an event is created";

export const ON_EXPIRE_LABELS = { none: "Stays overdue", review_task: "Create review task", route_status: "Move route to…" };

export function Field({ label, hint, children, className }) {
  return (
    <label className={cn("block", className)}>
      <span className="block text-[11px] font-medium text-slate-600 mb-1">{label}</span>
      {children}
      {hint && <span className="block text-[10px] text-muted-foreground mt-1">{hint}</span>}
    </label>
  );
}

export function NumInput({ value, onChange, min, max, className, testId, disabled, placeholder }) {
  return (
    <Input
      type="number" min={min} max={max} disabled={disabled} placeholder={placeholder}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))}
      className={cn("h-8 text-sm text-right tabular-nums", className)}
      data-testid={testId}
    />
  );
}

export function EnumSelect({ value, onChange, options, testId, disabled, className }) {
  return (
    <Select value={value ?? ""} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={cn("h-8 text-xs", className)} data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>
        {Object.entries(options).map(([k, v]) => <SelectItem key={k} value={k} className="text-xs">{v}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function SectionIntro({ title, children, badge }) {
  return (
    <div className="flex items-start justify-between gap-3 mb-3">
      <div>
        <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
        <p className="text-xs text-muted-foreground mt-0.5 max-w-3xl">{children}</p>
      </div>
      {badge}
    </div>
  );
}

export const StoredOnlyBadge = ({ what = "Stored only" }) => (
  <span className="shrink-0 text-[10px] uppercase tracking-wide px-2 py-0.5 rounded-full border border-amber-300 bg-amber-50 text-amber-800" data-testid="stored-only-badge">
    {what} · enforced from A2
  </span>
);

export const LiveBadge = ({ what = "Live" }) => (
  <span className="shrink-0 text-[10px] uppercase tracking-wide px-2 py-0.5 rounded-full border border-emerald-300 bg-emerald-50 text-emerald-800" data-testid="live-badge">
    {what}
  </span>
);
